import { render, staticRenderFns } from "./VendorCard.vue?vue&type=template&id=0e02cfd4&scoped=true"
import script from "./VendorCard.vue?vue&type=script&lang=js"
export * from "./VendorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e02cfd4",
  null
  
)

export default component.exports